import React, { useState } from "react";
import { Calendar, Wrench, Building } from 'lucide-react';
import TechLabAppointment from "./TechLabAppointment";
import AksarayBuildingAppointment from "./AksarayBuildingAppointment";
import AppointmentCalendar from "../components/AppointmentCalendar";
import "../styles/appointments.css";

const AppointmentPage = () => {
  const [activeSection, setActiveSection] = useState("tech_lab"); // tech_lab, aksaray, calendar

  return (
    <div className="appointment-page">
      <div className="page-header">
        <h1><Calendar className="inline-icon"/> Randevu Sistemi</h1>
        <p>Necmettin Erbakan Teknoloji Atölyesi ve Aksaray Hanımlar Binası randevu yönetimi</p>
      </div>

      <div className="section-tabs">
        <button
          className={`section-tab ${activeSection === "tech_lab" ? "active" : ""}`}
          onClick={() => setActiveSection("tech_lab")}
        >
          <Wrench className="inline-icon"/> Teknoloji Atölyesi
        </button>
        <button
          className={`section-tab ${activeSection === "aksaray" ? "active" : ""}`}
          onClick={() => setActiveSection("aksaray")}
        >
          <Building className="inline-icon"/> Aksaray Binası
        </button>
        <button
          className={`section-tab ${activeSection === "calendar" ? "active" : ""}`}
          onClick={() => setActiveSection("calendar")}
        >
          <Calendar className="inline-icon"/> Takvim
        </button>
      </div>

      <div className="section-content">
        {activeSection === "tech_lab" && <TechLabAppointment />}
        {activeSection === "aksaray" && <AksarayBuildingAppointment />}
        {activeSection === "calendar" && <AppointmentCalendar />}
      </div>
    </div>
  );
};

export default AppointmentPage;
